import React from 'react';
import { NavLink } from 'react-router-dom'

const Nav = () => {
  return (
    <nav className="is-flex">
      <ul className="nav-item">
        <li className="nav-item">
          <NavLink activeClassName="is-active" to="notes">View Notes</NavLink>
        </li>
        <li className="nav-item">
          <NavLink activeClassName="is-active" to="create" className="button is-info"> <i className="fa fa-pencil-square-o "></i>Create Note</NavLink>
        </li>
      </ul>
    </nav>
  )
}

export default Nav;



// WEBPACK FOOTER //
// ./src/Components/nav.js